"use client";

import { handleLogout } from "@/app/firebase/auth";
import React from "react";
import { Navigation } from "@anu-its/ts-react-components";
import { useUserStore } from "@/app/providers/UserStore";

export default function NavBar() {
  const {
    userDetails,
    userIsSuperAdmin,
    loading,
    hasHydrated,
    userIsOrgAdmin,
  } = useUserStore();

  function forceLogout() {
    handleLogout();
  }

  const createLink = userIsSuperAdmin ? "/create" : "/create/teaching-site";

  if (!hasHydrated || loading) {
    return null;
  }

  const navItems = [];
  if (userIsSuperAdmin || userIsOrgAdmin) {
    navItems.push({
      href: createLink,
      label: "Create Site",
      id: "create-site",
    });

    if (userIsSuperAdmin) {
      navItems.push({
        href: "/roles",
        label: "Roles Dashboard",
        id: "manage-roles",
      });
    }
  }

  navItems.push({
    href: "/",
    label: "Dashboard",
    id: "dashboard",
  });

  return (
    <Navigation
      {...(userDetails && !loading
        ? {
            user: {
              displayName: userDetails.displayName || "",
              email: userDetails.email || "",
              handleLogout: () => forceLogout,
            },
          }
        : {})}
      menuItems={navItems}
    />
  );
}
